module.exports = __webpack_public_path__ + "img/banner01-desktop-v2.47a81f04.png";